import React, { useMemo, useContext } from 'react';
import { styled } from '@mui/material';
import { useFieldArray } from 'react-hook-form';
import clsx from 'clsx';
import { getStyle } from './style';
import { FormContext } from './context';
import { getValidateRules } from './utils';
export function FormListBase(props) {
    const { name, children, rules, className } = props;
    const { validateMessages, form } = useContext(FormContext);
    const wrapRules = useMemo(() => getValidateRules(rules ?? [], {
        name,
        label: undefined,
        validateMessages,
    }), [name, rules, validateMessages]);
    const { fields, ...operations } = useFieldArray({
        name,
        rules: wrapRules,
        keyName: 'key',
    });
    const cls = clsx(className);
    return (React.createElement("div", { className: cls }, children(fields, operations, { errors: form.getFieldError(name) })));
}
const StyledFormList = styled(FormListBase)((props) => {
    const { theme } = props;
    return getStyle(theme);
});
export const FormList = React.forwardRef((props, ref) => (React.createElement(StyledFormList, { ...props, ref: ref })));
